import PropTypes from 'prop-types';
import React from 'react';
import {
    Meta,
    Footer
} from '$partials/global/index.js';
import GridModuleDispatcher from '$partials/grid/dispatcher.jsx';
import { NavigationPageWrapper, NavigationButton } from '$partials/navigation/index.js';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @param {PropTypes.InferProps<typeof propTypes>} props
 */
const TextPage = (props) => {
    const page = props.data.page;

    return (
        <>
            <Meta
                description={page.searchDescription || page.listingText}
                domain={props.domain}
                image={page.listingImage}
                page={page}
                title='Bureau for Visual Affairs' />

            <NavigationPageWrapper {...props.data?.navigation}>
                <main id='main-content'>
                    <div className='p-1'>

                        {/* Header */}
                        {/* py-20 sm:pb-40 sm:pt-34 md:pb-45 md:pt-30 lg:pt-40 lg:pb-80 */}
                        <header
                            className='layout-container flex flex-col gap-27 bg-foreground rounded mb-1 pt-20 pb-40 sm:pt-40 sm:pb-50 lg:pb-80'
                            style={{ backgroundColor: page.headerColour }}>
                            <h1 className='rounded flex gap-60 md:gap-220 type-style-2'>
                                <a
                                    className='flex flex-col px-layout-item mb-10 sm:mb-30'
                                    href={'/'}>
                                    <span>Bureau for</span>
                                    <span>Visual Affairs</span>
                                </a>
                            </h1>

                            <div className='type-style-hero-sm px-layout-item'>
                                <h2>{page?.displayTitle}</h2>
                            </div>

                            {page?.headerCopy &&
                                <div
                                    className='px-layout-item type-style-2 max-w-[30em] sm:max-w-[30em] rich-text md:mt-10 lg:mt-20'
                                    dangerouslySetInnerHTML={{ __html: page?.headerCopy }} />
                            }
                            <NavigationButton />
                        </header>

                        {/* Modules */}
                        <div>
                            {page?.modules?.map((item) => {
                                if (!item) { return null; }
                                return (
                                    <GridModuleDispatcher
                                        {...item}
                                        key={item?.id} />
                                );
                            })}
                        </div>

                        <Footer
                            mailchimpId={props?.data?.mailchimpId?.mailchimpId}
                            {...props?.data?.footer} />
                    </div>
                </main>
            </NavigationPageWrapper>
        </>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

const propTypes = {
    data: PropTypes.shape({
        page: PropTypes.object,
        footer: PropTypes.object,
        navigation: PropTypes.object,
        mailchimpId: PropTypes.object,
    }),
    domain: PropTypes.string,
};

TextPage.propTypes = propTypes;

export default TextPage;
